<template>
  <master-layout pageTitle="Manage Team">
    <div>
      <div class="team-toolbar">
        <div class="tabs-row">
          <button type="button" :class="['tab-item', { active: activeTab === 'team-members' }]" @click="changeTab('team-members')">Team members</button>
          <button type="button" :class="['tab-item', { active: activeTab === 'groups' }]" @click="changeTab('groups')">Groups</button>
        </div>
        <div class="toolbar-actions hide-mobile">
          <VButton class="vvd-btn-secondary" connotation="cta" appearance="outlined" label="Export Team members" style="min-width: 150px;" @click="csvExportWithDateRangeModal_open('UserRoles','Export team member\'s list')"></VButton>
          <div class="create-dropdown-wrapper">
            <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Create" icon="chevron-down-line" @click="createOptionsVisible = !createOptionsVisible"></VButton>
            <div v-if="createOptionsVisible" class="create-dropdown">
              <button type="button" class="dropdown-item" @click.stop="createTeamMembers('team-member')">Add team member</button>
              <button type="button" class="dropdown-item" @click.stop="createTeamMembers('group')">Create a new group</button>
            </div>
            <div v-if="createOptionsVisible" class="dropdown-backdrop" @click="createOptionsVisible = false"></div>
          </div>
        </div>
        <div class="toolbar-actions show-mobile">
          <ActionPopOver :style="{'--width': '200px'}">
            <div class="listContainer">
              <VButton class="vvd-btn-secondary vvd-btn-block" connotation="cta" appearance="outlined" label="Export Team members" @click="csvExportWithDateRangeModal_open('UserRoles','Export team member\'s list')"></VButton>
              <VButton class="vvd-btn-secondary vvd-btn-block" connotation="cta" appearance="outlined" label="Add team member" @click.stop="createTeamMembers('team-member')"></VButton>
              <VButton class="vvd-btn-secondary vvd-btn-block" connotation="cta" appearance="outlined" label="Create a new group" @click.stop="createTeamMembers('group')"></VButton>
            </div>
          </ActionPopOver>
        </div>
      </div>
      
        <!-- Team Members -->
        <div v-if="activeTab === 'team-members'" class="gridMargin">
          <div v-if="allMembers.length > 0">
            <!-- Admins Accordion -->
            <VAccordion expand-mode="multi">
              <VAccordionItem expanded class="accordion-container">
                <template #heading>
                  <span class="vtext-card-title">Admins</span>
                </template>
                <div>
                  <SearchBar v-model="adminFilter" placeholder="Search admins" :rightIcon="true" backgroundColor="var(--background-primary)" class="team-search-field vmb-10" />
                  <div class="table-header">
                    <div class="table-row">
                      <div class="table-cell cell-name"><span class="vtext-subtitle">Name</span></div>
                      <div class="table-cell cell-email hide-mobile"><span class="vtext-subtitle">Email</span></div>
                      <div class="table-cell cell-role"><span class="vtext-subtitle">Role</span></div>
                      <div class="table-cell cell-actions text-right"><span class="vtext-subtitle">Actions</span></div>
                    </div>
                  </div>
                  <div class="table-body">
                    <div v-for="member in adminsToShow" :key="member.id" class="table-row cust-brdr">
                      <div class="table-cell cell-name"><span class="vtext-body">{{ member.name }}</span></div>
                      <div class="table-cell cell-email hide-mobile"><span class="vtext-body">{{ member.email }}</span></div>
                      <div class="table-cell cell-role"><span class="vtext-body">{{ member.role }}</span></div>
                      <div class="table-cell cell-actions text-right hide-mobile">
                        <div class="actionContainer">
                          <VIcon name="edit-line" title="Edit" class="actionIcons cursorPointer" @click="() => $router.push('/settings/team/add-member?memberid=' + member.id)"></VIcon>
                          <VIcon name="delete-line" title="Delete" connotation="alert" class="actionIcons cursorPointer trashIcon" @click="() => memberToDelete = JSON.parse(JSON.stringify(member))"></VIcon>
                        </div>
                      </div>
                      <div class="table-cell cell-actions show-mobile">
                        <ActionPopOver :style="{'--width': '215px'}">
                          <div class="listContainer">
                            <span class="vtext-body">{{ member.email }}</span>
                            <VButton class="vvd-btn-secondary vvd-btn-block" connotation="cta" appearance="outlined" label="Edit" icon="edit-line" @click="() => $router.push('/settings/team/add-member?memberid=' + member.id)"></VButton>
                            <VButton class="vvd-btn-danger-outline vvd-btn-block" connotation="announcement" appearance="outlined" label="Delete" icon="delete-line" @click="() => memberToDelete = JSON.parse(JSON.stringify(member))"></VButton>
                          </div>
                        </ActionPopOver>
                      </div>
                    </div>
                    <div v-if="admins.length == 0" class="text-center emptyContainer">
                      <div>
                        <img src="@/resources/images/empty_team_members.svg" class="segmentImg" alt="empty" />
                        <h5>No Admins added yet!</h5>
                      </div>
                    </div>
                  </div>
                  <div class="text-center emptyContainer" v-if="adminFilter && adminFilter.length && adminsToShow.length == 0">
                    <div>
                      <img src="@/resources/images/empty_team_members.svg" class="segmentImg" alt="empty" />
                      <h5>No admins matching this filter! 😟 <a class="hyperlink_cust" @click="() => adminFilter = undefined">Clear filter</a></h5>
                    </div>
                  </div>
                </div>
              </VAccordionItem>

              <!-- Group Members Accordion -->
              <VAccordionItem expanded class="accordion-container">
                <template #heading>
                  <span class="vtext-card-title">Group members</span>
                </template>
                <div>
                  <div class="search-filter-row">
                    <SearchBar v-model="teamFilter" placeholder="Search group members" :rightIcon="true" backgroundColor="var(--background-primary)" class="search-input" />
                    <VIcon name="filter-line" :size="-5" class="cursorPointer filter-icon" @click="openFilterModal"></VIcon>
                  </div>
                  <div class="table-header">
                    <div class="table-row">
                      <div class="table-cell cell-name"><span class="vtext-subtitle">Name</span></div>
                      <div class="table-cell cell-email hide-mobile"><span class="vtext-subtitle">Email</span></div>
                      <div class="table-cell cell-role"><span class="vtext-subtitle">Role</span></div>
                      <div class="table-cell cell-actions text-right"><span class="vtext-subtitle">Actions</span></div>
                    </div>
                  </div>
                  <div class="table-body">
                    <div v-for="member in teamToShow" :key="member.id" class="table-row cust-brdr">
                      <div class="table-cell cell-name"><span class="vtext-body">{{ member.name }}</span></div>
                      <div class="table-cell cell-email hide-mobile"><span class="vtext-body">{{ member.email }}</span></div>
                      <div class="table-cell cell-role"><span class="vtext-body">{{ member.role }}</span></div>
                      <div class="table-cell cell-actions text-right hide-mobile">
                        <div class="actionContainer">
                          <VIcon name="edit-line" title="Edit" class="actionIcons cursorPointer" @click="() => $router.push('/settings/team/add-member?memberid=' + member.id)"></VIcon>
                          <VIcon name="delete-line" title="Delete" connotation="alert" class="actionIcons cursorPointer trashIcon" @click="() => memberToDelete = JSON.parse(JSON.stringify(member))"></VIcon>
                        </div>
                      </div>
                      <div class="table-cell cell-actions show-mobile">
                        <ActionPopOver :style="{'--width': '215px'}">
                          <div class="listContainer">
                            <span class="vtext-body">{{ member.email }}</span>
                            <VButton class="vvd-btn-secondary vvd-btn-block" connotation="cta" appearance="outlined" label="Edit" icon="edit-line" @click="() => $router.push('/settings/team/add-member?memberid=' + member.id)"></VButton>
                            <VButton class="vvd-btn-danger-outline vvd-btn-block" connotation="announcement" appearance="outlined" label="Delete" icon="delete-line" @click="() => memberToDelete = JSON.parse(JSON.stringify(member))"></VButton>
                          </div>
                        </ActionPopOver>
                      </div>
                    </div>
                    <div v-if="nonAdmins.length == 0" class="text-center emptyContainer">
                      <div>
                        <img src="@/resources/images/empty_team_members.svg" class="segmentImg" alt="empty" />
                        <h5>No group members added yet!</h5>
                      </div>
                    </div>
                  </div>
                  <div class="text-center emptyContainer" v-if="(teamFilter?.length || teamRoleFilter) && teamToShow.length == 0">
                    <div>
                      <img src="@/resources/images/empty_team_members.svg" class="segmentImg" alt="empty" />
                      <h5>No members matching this filter! 😟 <a class="hyperlink_cust" @click="() => {teamFilter = undefined; teamRoleFilter = undefined;}">Clear filter</a></h5>
                    </div>
                  </div>
                </div>
              </VAccordionItem>
            </VAccordion>
          </div>

          <div class="text-center emptyContainer" v-else-if="allMembers.length == 0">
            <div>
              <img src="@/resources/images/not-found.svg" class="segmentImg" alt="empty" />
              <h5>No members yet! 😟</h5>
            </div>
          </div>
        </div>
        <!-- Groups -->
        <div v-if="activeTab === 'groups'" class="gridMargin">
          <SearchBar v-model="groupFilter" placeholder="Search group" :rightIcon="true" class="team-search-field" />
          <div class="group_container">
          <div v-if="groupsToShow.length > 0" class="table-header">
            <div class="table-row">
              <div class="table-cell cell-half"><span class="vtext-subtitle">Name</span></div>
              <div class="table-cell cell-half text-right"><span class="vtext-subtitle">Actions</span></div>
            </div>
          </div>

          <div v-if="groupsToShow.length > 0" class="table-body">
            <div v-for="group in groupsToShow" :key="group.id" class="table-row cust-brdr">
              <div class="table-cell cell-half"><span class="vtext-body">{{ group.name }}</span></div>
              <div v-if="!group.default" class="table-cell cell-half text-right hide-mobile">
                <div class="actionContainer">
                  <VIcon name="edit-line" title="Edit" class="actionIcons cursorPointer" @click="() => $router.push('/settings/team/add-group?groupid=' + group.id)"></VIcon>
                  <VIcon name="delete-line" title="Delete" connotation="alert" class="actionIcons cursorPointer trashIcon" @click="() => groupToDelete = JSON.parse(JSON.stringify(group))"></VIcon>
                </div>
              </div>
              <div v-if="!group.default" class="table-cell cell-half text-right show-mobile">
                <ActionPopOver :style="{'--width': '215px'}">
                  <div class="listContainer">
                    <VButton class="vvd-btn-secondary vvd-btn-block" connotation="cta" appearance="outlined" label="Edit" icon="edit-line" @click="() => $router.push('/settings/team/add-group?groupid=' + group.id)"></VButton>
                    <VButton class="vvd-btn-danger-outline vvd-btn-block" connotation="announcement" appearance="outlined" label="Delete" icon="delete-line" @click="() => groupToDelete = JSON.parse(JSON.stringify(group))"></VButton>
                  </div>
                </ActionPopOver>
              </div>
            </div>
          </div>

          <div class="text-center" v-if="groupFilter && groupFilter.length && groupsToShow.length == 0">
            <img src="@/resources/images/empty_team_members.svg" class="segmentImg" alt="empty_group" />
            <h5>No groups matching this filter! 😟 <a class="hyperlink_cust" @click="() => groupFilter = undefined">Clear filter</a></h5>
          </div>

          <div class="text-center" v-if="allGroups.length == 0">
            <img src="@/resources/images/empty_team_members.svg" class="segmentImg" alt="empty_group" />
            <h5>No groups yet! 😟</h5>
          </div>
        </div>
        </div>
     </div>
    <!-- Reassign Member Modal -->
    <VDialog :open="memberToDelete !== null" headline="Re-assign your conversations and delete this user" modal @close="() => memberToDelete = null">
      <template #body>
        <div class="gridMargin">
          <h2 class="vtext-body vmb-20"> Before you delete this user <b>{{ memberToDelete?.name }} </b> you need to re-assign the conversations that are assigned to you to any of the user below.</h2>
          <div class="vrow">
            <div v-for="thisMember in reassignableMembers" :key="thisMember.id" class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 vmb-10">
              <div class="user-container" :class="{ selected: reassignId === thisMember.id }" @click="thisMember.id !== memberToDelete?.id ? reassignId = thisMember.id : null">
                <div class="user-row">
                  <VIcon :name="reassignId === thisMember.id ? 'radio-checked-line' : 'radio-unchecked-line'" :connotation="reassignId === thisMember.id ? 'cta' : undefined"></VIcon>
                  <img width="25" src="@/resources/images/single_person.svg" alt="member"/>
                  <span class="vtext-body">{{ thisMember.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" :label="commonLoader ? 'Re-assigning...' : 'Re-assign'" :disabled="reassignId == undefined || commonLoader" @click="reassignConversations"></VButton>
      </template>
    </VDialog>

    <!-- Confirm Delete Member -->
    <VDialog :open="confirmMemberToDelete" headline="Are you sure?" modal @close="() => { confirmMemberToDelete = false; memberToDelete = null; }">
      <template #body>
        <p class="vtext-body">You want to remove this member?</p>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="() => { confirmMemberToDelete = false; memberToDelete = null; }"></VButton>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="deleteMember()"></VButton>
      </template>
    </VDialog>

    <!-- Confirm Delete Group -->
    <VDialog :open="groupToDelete !== null" headline="Are you sure?" modal @close="() => groupToDelete = null">
      <template #body>
        <p class="vtext-body">You want to remove this group?</p>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="() => groupToDelete = null"></VButton>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="deleteGroup()"></VButton>
      </template>
    </VDialog>

    <!-- Filter Modal -->
    <VDialog :open="filterModal" headline="Filter by group" modal @close="dismissFilter()">
      <template #body>
        <div class="gridMargin filterContainer">
          <div v-if="teamRoleFilter" class="filter-option" :class="{ active: teamRoleFilter === '' }" @click="teamRoleFilter = ''">
            <VIcon :name="teamRoleFilter === '' ? 'radio-checked-line' : 'radio-unchecked-line'" :connotation="teamRoleFilter === '' ? 'cta' : undefined"></VIcon>
            <span class="vtext-subtitle">-- Show all members --</span>
          </div>
          <div v-for="group in filteredGroups" :key="group.id" class="filter-option" :class="{ active: teamRoleFilter === group.name }" @click="teamRoleFilter = group.name">
            <VIcon :name="teamRoleFilter === group.name ? 'radio-checked-line' : 'radio-unchecked-line'" :connotation="teamRoleFilter === group.name ? 'cta' : undefined"></VIcon>
            <span class="vtext-subtitle">{{ group.name }}</span>
          </div>
        </div>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Close" @click="dismissFilter"></VButton>
      </template>
    </VDialog>

    <exports-modal-v2 v-if="csvExportWithDateRangeModal" type="teamMembers" :isOpen="csvExportWithDateRangeModal" :title="csvExportWithDateRangeModal_title" @close="() => csvExportWithDateRangeModal = false"></exports-modal-v2>
  </master-layout>
</template>

<script>
import '@/resources/css/manage-store.css';
import ActionPopOver from "@/components/ActionPopOver.vue";
import exportsModalV2 from '@/components/exportModalV2';
import { useCsvExportModal } from '@/composables/useCsvExportModal';
import apiInterceptor from '@/shared/apiInterceptor';
import { queryClient } from '@/shared/queryClient';
import { teamMembersQueryOptions } from '@/composables/useTeamMembers';
import { businessRolesQueryOptions } from '@/composables/useBusinessRoles';
import { useUIStore } from '@/stores/ui';
import SearchBar from '@/components/SearchBar.vue';
import { environment } from '@/shared/env';

export default {
  setup() {
    return useCsvExportModal();
  },
  components: {
    ActionPopOver,
    SearchBar,
    exportsModalV2
  },
  data() {
    return {
      activeTab: 'team-members',
      allMembers: [],
      membersLoaded: false,
      allGroups: [],
      groupsLoaded: false,
      memberToDelete: null,
      groupToDelete: null,
      confirmMemberToDelete: false,
      reassignId: undefined,
      teamFilter: undefined,
      teamRoleFilter: undefined,
      groupFilter: undefined,
      adminFilter: undefined,
      admins: [],
      nonAdmins: [],
      commonLoader: false,
      filterModal: false,
      createOptionsVisible: undefined
    }
  },
  computed: {
    teamToShow() {
      const filterRegex = new RegExp(this.teamFilter, 'gi');
      if(this.teamRoleFilter && this.teamFilter?.length) return this.nonAdmins.filter(e => e.role === this.teamRoleFilter && e.name.match(filterRegex));
      else if(this.teamRoleFilter) return this.nonAdmins.filter(e => e.role === this.teamRoleFilter);
      else if(this.teamFilter?.length) return this.nonAdmins.filter(e => e.name.match(filterRegex));
      return this.nonAdmins;
    },
    adminsToShow() {
      return this.adminFilter && this.adminFilter.length ? this.admins.filter(e => e.name.match(new RegExp(this.adminFilter, 'gi'))) : this.admins;
    },
    groupsToShow() {
      return this.groupFilter && this.groupFilter.length ? this.allGroups.filter(e => e.name.match(new RegExp(this.groupFilter, 'gi'))) : this.allGroups;
    },
    filteredGroups() {
      return this.allGroups.filter(group => !group.admin);
    },
    reassignableMembers() {
      return this.allMembers.filter(e => e.id !== this.memberToDelete?.id);
    }
  },
  async mounted() {
    const members = await this.fetchMembers();
    const groups = await this.fetchGroups();
    await Promise.all([members, groups]);
  },
  methods: {
    doRefresh() {
      queryClient.invalidateQueries({ queryKey: ['team-members'] });
      queryClient.invalidateQueries({ queryKey: ['business-roles'] });
      this.membersLoaded = false;
      this.groupsLoaded = false;
      this.changeTab('team-members');
    },
    changeTab(newTab) {
      this.activeTab = newTab;
      switch(this.activeTab) {
        case 'team-members': !this.membersLoaded ? this.fetchMembers() : '';
        break;
        case 'groups': !this.groupsLoaded ? this.fetchGroups() : '';
        break;
        default: useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      }
    },
    async fetchMembers() {
      try {
        useUIStore().updateLoading({ isLoading: true });
        this.allMembers = await queryClient.fetchQuery({ ...teamMembersQueryOptions, staleTime: 0 });
        this.admins = this.allMembers.filter(user => user.is_admin);
        this.nonAdmins = this.allMembers.filter(user => !user.is_admin);
        this.membersLoaded = true;
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong!", type: "danger" });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async fetchGroups() {
      try {
        useUIStore().updateLoading({ isLoading: true });
        this.allGroups = await queryClient.fetchQuery({ ...businessRolesQueryOptions, staleTime: 0 });
        this.groupsLoaded = true;
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong!", type: "danger" });
        console.error("Exception", error);
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async reassignConversations() {
      if(this.reassignId && this.memberToDelete.id) {
        try {
          this.commonLoader = true;
          const reqBody = {
            old_agent_id: this.memberToDelete.id,
            new_agent_id: this.reassignId
          }
          await apiInterceptor.post( environment("VUE_APP_API_URL") + "roles/v1/routing/", reqBody);
          useUIStore().updateLoading({ isLoading: false });
          useUIStore().updateToast({
            open: true,
            message: "Reassigned successfully",
            type: "success"
          })
          this.confirmMemberToDelete = true;
         
        } catch (error) {
          useUIStore().updateToast({
            open: true,
            message: error.message || "Something went wrong",
            type: "danger"
          })
        } finally {
          this.commonLoader = false
        }
      } else {
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong, please try again",
          type: "danger"
        })
      }
    },
    async deleteMember() {
      try {
        useUIStore().updateLoading({ isLoading: true });

        if(!this.memberToDelete.email) {
          useUIStore().updateToast({
            open: true,
            message: "Something went wrong, please try again",
            type: "error"
          })
          useUIStore().updateLoading({ isLoading: false });
          return;
        }
        let reqBody = { email: this.memberToDelete.email };
        const params = {
          ...reqBody
        }
        await apiInterceptor.delete( environment("VUE_APP_API_URL") + "roles/v1/team_members/", { params });
        queryClient.invalidateQueries({ queryKey: ['team-members'] });
        useUIStore().updateToast({
          open: true,
          message: "Member deleted successfully",
          type: "success"
        })
        await this.fetchMembers();
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong",
          type: "danger"
        })
      } finally {
        useUIStore().updateLoading({ isLoading: false });
        this.memberToDelete = null;
        this.reassignId = undefined;
        this.confirmMemberToDelete = false;
      }
    },
    async deleteGroup() {
      try {
        useUIStore().updateLoading({ isLoading: true });

        if(!this.groupToDelete.id) {
          useUIStore().updateToast({
            open: true,
            message: "Something went wrong, please try again",
            type: "error"
          })
          return;
        }
        await apiInterceptor.delete(environment('VUE_APP_API_URL') + `roles/v1/business_roles/${this.groupToDelete.id}`);
        queryClient.invalidateQueries({ queryKey: ['business-roles'] });
        queryClient.invalidateQueries({ queryKey: ['livechat-business-roles'] });
        useUIStore().updateToast({
          open: true,
          message: "Group deleted successfully",
          type: "success"
        })
        await this.fetchGroups();
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong",
          type: "danger"
        })
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    addTeamMembers() {
      this.$router.push('/settings/team/add-member');
      // removing temporarliy add team members limit
      // const allowedNumberOfMembers = this.jupiter?.permissions?.allowedNumberOfMembers || 10;
      // if (this.allMembers.length < allowedNumberOfMembers) {
      //   this.$router.push('/settings/team/add-member');
      // } else {
      //   useUIStore().updateToast({ open: true, message: `Sorry You cannot add More than ${allowedNumberOfMembers} Team members`, type: "warning" });
      // }
    },
    createTeamMembers(option) {
      if(option == 'team-member') {
        this.addTeamMembers();
      } else if(option == 'group') {
        this.$router.push('/settings/team/add-group');
      }
      this.createOptionsVisible = undefined;
    },
    openFilterModal(){
      this.filterModal = true;
    },
    dismissFilter() {
      this.filterModal = false;
    }
  }
}
</script>

<style lang="scss" scoped src="@/resources/css/settings.scss"> </style>

<style scoped>
.team-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--white);
  border-bottom: 1px solid var(--background-primary);
}

.tabs-row {
  display: flex;
}

.tab-item {
  padding: 10px 20px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 14px;
  font-weight: 400;
  color: var(--black);
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;
  transition: border-color 0.2s, color 0.2s;
}

.tab-item:hover {
  color: var(--purple);
}

.tab-item.active {
  color: var(--purple);
  border-bottom-color: var(--purple);
  font-weight: 500;
}

.toolbar-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.create-dropdown-wrapper {
  position: relative;
}

.create-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1000;
  background: var(--white);
  border-radius: 5px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 10px;
  min-width: 180px;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 10px 12px;
  border: none;
  background: none;
  text-align: left;
  font: inherit;
  font-size: 14px;
  color: var(--black);
  cursor: pointer;
  border-radius: 5px;
}

.dropdown-item:hover {
  background: var(--background-primary);
}

.dropdown-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

.accordion-container{
  background: var(--white);
  border-radius: 5px;
  margin-bottom: 20px;
}
/* Table Grid Layout */
.table-header {
  border-bottom: 1px solid var(--background-primary);
  margin: 0px;
}
.table-row {
  display: grid;
  grid-template-columns: 2fr 2fr 1fr 1fr;
  align-items: center;
  padding: 15px 0;
}

.table-body .table-row.cust-brdr:last-child {
  border-bottom: none;
}

.search-filter-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.search-filter-row .search-input {
  flex: 1;
  max-width: 300px;
}

.filter-icon {
  color: var(--gray-04);
  padding: 8px;
  border-radius: 5px;
}

.filter-icon:hover {
  background: var(--background-primary);
}

.table-cell {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cell-name { grid-column: 1; }
.cell-email { grid-column: 2; }
.cell-role { grid-column: 3; }
.cell-actions { grid-column: 4; }
.cell-half { flex: 1; }

/* Groups table - 2 columns */
.gridMargin > .table-header .table-row,
.gridMargin > .table-body .table-row {
  grid-template-columns: 1fr 1fr;
}

/* User Container (Reassign) */
.user-container {
  border: 1px solid var(--background-primary);
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
  margin-bottom: 10px;
}

.user-container.selected {
  border-color: var(--purple);
}

.user-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Filter Modal */
.filterContainer {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.filter-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  cursor: pointer;
}

.filter-option.active {
  color: var(--purple);
}
.team-search-field {
  width: 25%;
}
.group_container{
  background: var(--white);
  margin: 20px 0px 0px 0px;
  border-radius: 5px;
  padding: 20px;
}
/* Responsive */
.show-mobile { display: none; }

@media only screen and (max-width: 760px) {
  .hide-mobile { display: none !important; }
  .show-mobile { display: block !important; }
  
  .table-row {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .team-toolbar {
    flex-wrap: wrap;
    gap: 10px;
  }
}
</style>


